import { useState } from "react";
import { Search, Music, Image as ImageIcon } from "lucide-react";
import { ScrollArea } from "@/client/components/ui/scroll-area";
import { Input } from "@/client/components/ui/input";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/client/components/ui/accordion";
import { AudioAssetsPanel } from "@/client/components/assets/audio-assets-panel";
import { ImagesPanel } from "./images-panel";

interface FilesPanelProps {
  storyId: string;
}

export function FilesPanel({ storyId }: FilesPanelProps) {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <>
      <div className="p-3 border-b">
        <div className="relative">
          <Search className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search files..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-8 h-8 text-sm"
          />
        </div>
      </div>

      <ScrollArea className="flex-1 min-h-0">
        <Accordion
          type="multiple"
          defaultValue={["audio", "images"]}
          className="px-2 py-1"
        >
          {/* Audio Section */}
          <AccordionItem value="audio" className="border-b-0">
            <AccordionTrigger
              style={{ alignItems: "center" }}
              className="py-2 hover:no-underline gap-1"
            >
              <div className="flex items-center gap-2 text-sm">
                <Music className="h-4 w-4 text-muted-foreground shrink-0" />
                <span>Audio</span>
              </div>
            </AccordionTrigger>
            <AccordionContent className="pb-2">
              <AudioAssetsPanel storyId={storyId} maxHeight="max-h-[250px]" />
            </AccordionContent>
          </AccordionItem>

          {/* Images Section */}
          <AccordionItem value="images" className="border-b-0">
            <AccordionTrigger
              style={{ alignItems: "center" }}
              className="py-2 hover:no-underline gap-1"
            >
              <div className="flex items-center gap-2 text-sm">
                <ImageIcon className="h-4 w-4 text-muted-foreground shrink-0" />
                <span>Images</span>
              </div>
            </AccordionTrigger>
            <AccordionContent className="pb-2">
              <ImagesPanel storyId={storyId} searchQuery={searchQuery} />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </ScrollArea>
    </>
  );
}
